import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Link as ChakraLink, forwardRef } from '@chakra-ui/react';

const Link = forwardRef((props, ref) => {
  const { to, ...restOfProps } = props;

  const url = () => {
    const { internal, external } = to;
    if (internal) {
      const base = internal.section === 'single' ? '' : `${internal.section}/`;
      return `/${base}${internal.slug.current}/`;
    }
    if (external) {
      return external;
    }

    return to;
  };

  if (!to) {
    return <ChakraLink {...restOfProps} ref={ref} />;
  }

  if (typeof to === 'string' && to !== '/') {
    return <ChakraLink {...restOfProps} ref={ref} />;
  }

  return <ChakraLink as={GatsbyLink} to={url()} {...restOfProps} ref={ref} />;
});

export default Link;
